module.exports = __webpack_public_path__ + "af7dfe2e6623ce43d0d82d9685e1b0c5.pdf";